import React, { useEffect, useState, useContext, useRef, ElementRef } from 'react';
import { useParams, useHistory } from "react-router-dom";
import { createBrowserHistory } from 'history';
import { EventService } from '../../models/event-service';
import { ServiceRegistry } from '../../models/service-registry';
import EventFilter from '../eventfilter/eventfilter';
import moment from 'moment-timezone';
import { FilterStorage } from '../../models/filterstorage';
import EventTile from '../eventtile/eventtile';
import Filter from '../filter/filter';
import { CasCadingFilterProp, EventType, FilterKey, Incident, Status, SubscriptionType } from '../../proptype';
import EmptyMyEventsMessage from '../emptymyeventsmessage/emptymyeventsmessage';
import MyEventsToggle from '../myeventstoggle/myeventstoggle';
import Select from 'react-select';
import Spinner from '../spinner/spinner';
import parse from 'html-react-parser';
import { clearPageState, isHistory, isToday, toggle_visibility, HideFooter, Subscribed, isCommunication, getMyEventsPref, setMyEventsPref, MY_EVENTS_PREF_KEY, resolveMyEventsPref } from '../../utils';
import { ConfigContext } from "../../App";
import { SubscriptionService } from '../../models/subscription-service';
import ProductTable from '../producttable/producttable';
import { IMS_EVENT, OMEGA_ENV, SUBMENU } from '../../constants';
import BreadCrumbs from '../breadcrumbs/breadcrumbs';
import Banner from '../banner/banner';
import ContentLoader from 'react-content-loader';
import OMEGA from '../../omega';
import GenericError from '../genericerror/genericerror';
const PDFJS = require("pdfjs-dist/build/pdf");
const pdfjsWorker = require("pdfjs-dist/build/pdf.worker.entry");
declare global {
    interface Window {
        pdfjsLib: any,
        PDFJS:any
    }
}

// Add style override for react-select contrast fix
const selectStyles = {
    option: (provided: any, state: any) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#1565C0' : provided.backgroundColor,
        ...(state.isFocused ? { outline: '2px solid #005FCC', outlineOffset: '-2px' } : {})
    })
};

export default function Events() {

    const eventDefaultValue = {
        element: "Events",
        action: "click",
        type: "List items",
        widget: {
            name: "event",
            type: "component"
        }
    }

    function omega_capture(element: any, widget_name: any, widget_type: any) {
        OMEGA.init().updateAndTrack("event", [{
            ...eventDefaultValue,
            element: element,
            widget: {
                name: widget_name,
                type: widget_type
            },
        }]);
    }

    const MyLoader = (props: any) => (
        <ContentLoader
            speed={2}
            width={150}
            height={47}
            backgroundColor="#f3f3f3"
            foregroundColor="#dcdcdc"
            {...props}
        >
            <rect x="0" y="20" rx="3" ry="3" width="100%" height="20" />
        </ContentLoader>
    );

    const locales = useContext(ConfigContext).appConfig.languageData;
    const updateMenu = useContext(ConfigContext).updateMenu;

    const STATUS_FILTER_VALUES = new Map([
        ['all', {value: 'all', label: locales.all_status}],
        [Status.Opened, {value: Status.Opened, label: locales.status[1]}],
        [Status.Closed, {value: Status.Closed, label: locales.status[4]}],
        [Status.Scheduled, { value: Status.Scheduled, label: locales.status[9]}],
        [Status.Started, {value: Status.Started, label: locales.status[2]}],
        [Status.Completed, { value: Status.Completed, label: locales.status[6]}],
        ]);
    let statusRef: any = null;

    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);
    const [events, setEvents] = useState<any[]>([]);
    const [allEvents, setAllEvents] = useState<any[]>([]);
    const [scheduledMaintenences, setScheduledMaintenences] = useState<Incident[]>([]);
    const [eventFilter, setEventFilter] = useState('all');
    const [statusFilter, setStatusFilter] = useState(STATUS_FILTER_VALUES.get('all'));
    const [productName, setProductName] = useState('');
    const [cloudId, setCloudId] = useState('');
    const [cloudName, setCloudName] = useState('');
    const [subscriptions, setSubscriptions] = useState<any[]>([]);
    const [selfSubscriptions, setSelfSubscriptions] = useState<any[]>([]);
    const [entitlements, setEntitlements] = useState<any[]>([]);
    const [filterCount, setFilterCount] = useState(0);
    const [loadingSubscription, setLoadingSubscription] = useState(false);
    const [subscriptionError, setSubscriptionError] = useState(false);
    const [currentTab, setCurrentTab] = useState("services");
    const [isServices, setIsServices] = useState(false);
    const [isFilterChanged, setFilterChanged] = useState(null);
    const [showCFS, setShowCFS] = useState(false);
    const [cfsError, setCfsError] = useState(false);
    const [cfsLoading, setCfsLoading] = useState(false);
    const [loadHistory, setLoadHistory] = useState(false);
    const [openEvent, setOpenEvent] = useState(false);
    const [lastCFSEvent, setLastCFSEvent] = useState('');
    const histroyAPI = useHistory();
    const [filterClicked, setFilterClicked] = useState(false);
    const [mounted, setMounted] = useState(true);
    const [isUpdated, setIsUpdated] = useState(false);
    const [clearAll, setClearAll] = useState(false);
    const [customDate,setCustomDate] = useState("");
    const [selectedOffering, setSelectedOfferings] = useState(null);
    const [customRegions, setCustomRegions] = useState(false);
    const [customeventIds, setCustomEventIds] = useState(false);
    const [isSubscribedView, setIsSubscribedView] = useState(false);
    const [myEventsDataReady, setMyEventsDataReady] = useState(false);
    const [preferMyEvents, setPreferMyEvents] = useState(false);
    const [tooltipExpanded, setTooltipExpanded] = useState(false);
    const appliedMyEventsDefaultRef = useRef(false);


    const { eventId, productId }: any = useParams();

    var filterObj: FilterStorage = FilterStorage.init(cloudId);
    const eventService: EventService = EventService.init();
    eventService.setLocales(locales);
    localStorage.removeItem('filterObj');
    const serviceRegistry: ServiceRegistry = ServiceRegistry.init();
    const subscriptionService: SubscriptionService = SubscriptionService.init();

    const handleClickMyEvents = () => {
        if (!window.adobeIMS?.isSignedInUser()) {
            sessionStorage.setItem('pendingReturnPath', window.location.pathname);
            window.adobeid.redirect_uri = window.location.href;
            window.adobeIMS.signIn();
            return;
        }
        // Persisting is conditional (below) so an empty My Events selection doesn't carry
        // forward to other product pages, but the toggle itself must still switch on for this
        // page - otherwise clicking My Events with zero events looks like the click did nothing.
        const hasEvents = hasAnyMyEvents();
        setMyEventsPref(MY_EVENTS_PREF_KEY, hasEvents ? 'myevents' : 'all');
        setPreferMyEvents(true);
        setIsSubscribedView(true);
        OMEGA.init().updateAndTrack('event', [{
            ...eventDefaultValue,
            element: 'My Events',
            widget: { name: 'product events tab', type: 'panel' },
        }]);
    };

    function isMyEventForCurrentProduct(incident: any) {
        return eventService.isMyEventForProduct(
            incident,
            subscriptions,
            selfSubscriptions,
            entitlements,
            productId
        );
    }

    function hasAnyMyEvents() {
        return eventService.getMyEvents(subscriptions, selfSubscriptions, entitlements).length > 0;
    }

    const handleClickAllProductEvents = () => {
        if (window.adobeIMS?.isSignedInUser()) {
            setMyEventsPref(MY_EVENTS_PREF_KEY, 'all');
        }
        setPreferMyEvents(false);
        setIsSubscribedView(false);
        OMEGA.init().updateAndTrack('event', [{
            ...eventDefaultValue,
            element: 'All Events',
            widget: { name: 'product events tab', type: 'panel' },
        }]);
    };

    function applyProductEventsTabPreference(hasEventDeepLink?: boolean) {
        if (hasEventDeepLink) {
            setPreferMyEvents(false);
            setIsSubscribedView(false);
            return;
        }
        appliedMyEventsDefaultRef.current = false;
        const myEvents = resolveMyEventsPref();
        setPreferMyEvents(myEvents);
        setIsSubscribedView(myEvents);
    }

    useEffect(() => {
        if (!myEventsDataReady || appliedMyEventsDefaultRef.current) {
            return;
        }
        appliedMyEventsDefaultRef.current = true;
        if (preferMyEvents && window.adobeIMS?.isSignedInUser() && !hasAnyMyEvents()) {
            // Nothing to show in My Events by default - fall back to All Events silently.
            // Only applies to the initial/default resolution, never to an explicit manual toggle.
            setPreferMyEvents(false);
            setIsSubscribedView(false);
        } else {
            setIsSubscribedView(preferMyEvents);
        }
    }, [myEventsDataReady, preferMyEvents]);

    function isMyEventsViewActive() {
        return window.adobeIMS?.isSignedInUser()
            && myEventsDataReady
            && (isSubscribedView || preferMyEvents);
    }

    function isWaitingForMyEventsData() {
        return window.adobeIMS?.isSignedInUser()
            && (preferMyEvents || isSubscribedView)
            && !myEventsDataReady;
    }

    function getFilteredEventsForView() {
        if (!isMyEventsViewActive()) {
            return { dayEvents: events, scheduled: scheduledMaintenences };
        }
        const dayEvents = events.map((dayEvent: any) => ({
            ...dayEvent,
            incidents: (dayEvent.incidents || []).filter((incident: any) => isMyEventForCurrentProduct(incident)),
        }));
        const scheduled = scheduledMaintenences.filter((maintenence: any) => isMyEventForCurrentProduct(maintenence));
        return { dayEvents, scheduled };
    }

    useEffect(() => {


        if (statusRef) {
            let filteredStatus:any = STATUS_FILTER_VALUES.get(statusFilter?.value||'all');
            statusRef.setState({
                inputValue: "",
                menuIsOpen: false,
                value: filteredStatus.length ? filteredStatus[0] : statusFilter
            });
        }
        filterObj = FilterStorage.init(cloudId);
        filterObj.setContext({
            type: 'product',
            cloud: cloudId
        });
        let incidents: any = eventService.getIncidentsByDate(filterObj.getValue() || {
            products: productId,
            date: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
            offerings: [],
            regions: [],
            environments: []
        }, 'all', eventFilter, statusFilter);

        setEvents(incidents);


    }, [eventFilter, statusFilter, isFilterChanged ]);


    useEffect(() => {
        if ((loadHistory || openEvent) && !loading && typeof eventId === 'string') {

            const _element = document.querySelector(`.id-${eventId}`);
            if (_element) {
                _element.classList.add('active');
                setTimeout(() => {
                    _element.scrollIntoView({
                        behavior: 'smooth'
                    });
                }, 200)
                setOpenEvent(false);
                setLoadHistory(false);
            }

        }
    }, [loadHistory, openEvent, loading]);

    useEffect(() => {
        if (isUpdated) {
            onFilterChange();
            setIsUpdated(false);
        }
    }, [isUpdated]);

    useEffect(() => {
        if(currentTab==="services"){setCustomDate("");}
    }, [currentTab]);


     useEffect(() => {
        if (clearAll) {
            onFilterChange();
            setClearAll(false);
        }
    }, [clearAll]);

    useEffect(() => {
        if (window.adobeIMS) {
            getAllData();
        } else {
            document.addEventListener(IMS_EVENT, getAllData);
        }
        eventService.registerForUpdate(() => {
            setIsUpdated(true);
        })
        return () => {
            setMounted(false);
            document.removeEventListener(IMS_EVENT, getAllData);
        }

    }, []);


    function getAllData() {

        let cfsMatches = window.location.search.match(/cfs=true/)
        const [servicePromise, productPromise]: any = [serviceRegistry.fetch(), eventService.fetch()];
        window.scrollTo(0, 0);

        if (window.adobeIMS?.isSignedInUser()) {
            setLoading(true);
            setMyEventsDataReady(false);
            subscriptionService.clearMyEventsContextCache();
        }

        Promise.all([servicePromise, productPromise])
            .then((results) => {
                if (mounted) {
                    let state: any = histroyAPI.location.state;
                    let safe: boolean = !!state?.page;
                    if (safe) {
                        clearPageState(createBrowserHistory());
                    }
                    const myEventsPromise = window.adobeIMS?.isSignedInUser()
                        ? subscriptionService.fetchMyEventsContext(serviceRegistry, safe)
                        : Promise.resolve(null);

                    if (window.adobeIMS?.isSignedInUser()) {
                        setLoadingSubscription(true);
                    }

                    const finishPageLoad = () => {
                        if (!mounted) {
                            return;
                        }
                        setFilterCount(getFilterCount());
                        setLoading(false);
                        histroyAPI.replace({});
                    };

                    myEventsPromise.then((context) => {
                        if (!mounted) {
                            return;
                        }
                        if (context) {
                            setSubscriptions(context.eventSubscription);
                            setSelfSubscriptions(context.selfSubscriptions);
                            setEntitlements(context.entitlements);
                        }
                        setMyEventsDataReady(true);
                        setLoadingSubscription(false);
                    }).catch((error: any) => {
                        console.error('Error in events subscription promises:', error);
                        omega_capture(
                            `Error in events subscription promises: ${error.message || error.toString()}`,
                            "event",
                            "error"
                        );
                        setMyEventsDataReady(true);
                        setLoadingSubscription(false);
                        setSubscriptionError(true);
                    }).finally(finishPageLoad);

                    let productName = serviceRegistry.getProductName(productId);
                    setProductName(productName);
                    let hierarchy_web = "";
                    if (window.location.hash) {
                        hierarchy_web = `home:notification:${window.location.hash}`
                    }
                    else {
                        hierarchy_web = `home:cloud:product`
                    }

                    OMEGA.init().updateAndTrack('page', {
                        hierarchy: hierarchy_web,
                        name: productName,
                        url: encodeURIComponent(window.location.href),
                        type: "home",
                        env: OMEGA_ENV
                    });

                    if (window.location.hash) {
                        histroyAPI.push(window.location.pathname);
                    }

                    let cloud: any = serviceRegistry.getCloudId(productId);
                    let currentMenu = SUBMENU.filter((menu: any) => menu.id === cloud);
                    updateMenu(currentMenu[0].name);

                    if (cloud) {
                        filterObj = FilterStorage.init(cloud);
                        filterObj.setContext({
                            type: 'product',
                            cloud: cloud
                        });
                        filterObj.resetAll(cloud);

                        setCloudId(cloud);
                        setCloudName(serviceRegistry.getCloudName(productId));

                        applyProductEventsTabPreference(!!eventId);

                        if (eventId) {
                            if (cfsMatches?.length) {
                                let cfsId = eventService.findLatestCFS(eventId, productId);
                                if (cfsId) {
                                    openCFS(cfsId, eventId);
                                }
                            }
                            let incident = eventService.getIncident(eventId);
                         
                            if (incident) {
                                let eventEndDate,
                                    offsetDay = moment(new Date().setDate(new Date().getDate() - 39));

                                if (incident.eventType === EventType.maintenance) {
                                    eventEndDate = incident.endedOn && moment(moment.unix(incident.endedOn).format('YYYY-MM-DD'));
                                } else {
                                    if (incident.products && incident.products[productId]) {
                                        eventEndDate = incident.products[productId].endedOn && moment(moment.unix(incident.products[productId].endedOn).format('YYYY-MM-DD'))
                                    }
                                }

                                if (eventEndDate && [Status.Closed, Status.Completed, Status.Canceled].includes(incident.status) && offsetDay.isSameOrBefore(eventEndDate, 'days')) {
                                  
                                    filterObj.setValue('date', [ moment().subtract(40, 'days').format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')]);
                              
                                  
                                    setLoadHistory(true);
                                }else if(incident?.severity === "Trivial"){
                                    eventEndDate = incident.updatedTime && moment(moment.unix(incident.updatedTime).format('YYYY-MM-DD'));
                                    if(eventEndDate && offsetDay.isSameOrBefore(eventEndDate, 'days')){
                                        filterObj.setValue('date', [moment().subtract(40, 'days').format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')]);
                                    }
                                    setLoadHistory(true);
                                }
                                setOpenEvent(true);
                            }
                            setCurrentTab('events');
                        }

                        let filter = filterObj.getValue();
                        if (filter?.date && !filter.date.length) {
                            filterObj.setValue('date', [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')])
                        }
                        let customHistotyDate: any = moment().format('YYYY-MM-DD');
                          if (histroyAPI.location && histroyAPI.location.state ){
                            var currentstate: any = histroyAPI.location.state;
                                if (currentstate?.filterDate && Array.isArray(currentstate?.filterDate)){
                                    filterObj.setValue('date', currentstate.filterDate);
                                    setEventFilter("all");
                                }else if(currentstate?.filterDate){
                                    customHistotyDate = currentstate.filterDate;
                                    filterObj.setValue('date', [customHistotyDate,customHistotyDate])
                                    setCustomDate(currentstate.filterDate); 
                                    setEventFilter("all");
                                }else if(currentstate?.DateRange){
                                    if(currentstate.DateRange==="last7Days"){
                                        filterObj.setValue('date', [moment().subtract(7, 'days').format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')]);
                                    }else if(currentstate.DateRange==="last40Days"){
                                        filterObj.setValue('date', [moment().subtract(40, 'days').format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')]); 
                                    }
                                    setEventFilter("all");
                                }
                                if(currentstate?.regions){
                                    filterObj.setValue('regions', currentstate.regions);
                                    setCustomRegions(currentstate.regions);
                   
                                }
                                if(currentstate?.eventIDs){
                                    filterObj.setValue('eventIds', currentstate.eventIDs);
                                    setCustomEventIds(currentstate.eventIDs);
               
                                }
                               
                            }
                        filterObj.setValue('products', productId);
                        let incidents: any = eventService.getIncidentsByDate(filterObj.getValue() || {
                            products: productId,
                            date: [customHistotyDate, customHistotyDate ],
                            offerings: [],
                            regions: [],
                            environments: [],
                            eventIds: []
                        }, 'all', 'all', statusFilter);
                        let scheduledMaintenances: any = eventService.getScheduledMaintenance(filter || {});
                        setEvents(incidents);
                        setAllEvents(incidents);
                        setScheduledMaintenences(scheduledMaintenances);
                    }

                    if (serviceRegistry.getOfferingsbyProduct(productId)?.length) {
                        setIsServices(true);
                    } else {
                        setCurrentTab("events");
                    }

                    if (histroyAPI.location && histroyAPI.location.state) {
                        setCurrentTab("events");
                        let state: any = histroyAPI.location.state;
                        let eventType = state?.eventType;
                        if(eventType && eventType!==""){
                            setEventFilter(eventType);
                        }
                        if (state.statusType === Status.Scheduled) {
                            setStatusFilter(STATUS_FILTER_VALUES.get(Status.Scheduled))
                            setEventFilter("all");
                        }
                        if(state.tab && state.tab === "services"){
                            setCurrentTab(state.tab);
                        }
                    }


                  

                }
            }).catch((error: any) => {
                console.error('Error in events service promises:', error);
                omega_capture(
                    `Error in events service promises: ${error.message || error.toString()}`,
                    "event",
                    "error"
                );
                setLoading(false);
                setError(true);
            })

        return () => {
            setMounted(false);
        }
    }


    function getFilterCount(_eventFilter?: string) {

        filterObj = FilterStorage.init(cloudId);
        filterObj.setContext({
            type: 'product',
            cloud: cloudId
        });

        let filter: CasCadingFilterProp | undefined = filterObj.getValue(), count = 0;
        if (filter) {
            Object.keys(filter).forEach((key: string) => {
                if (filter && key !== FilterKey.Products && filter[key as keyof CasCadingFilterProp]?.length) {
                    count++;
                }

                if (key === FilterKey.Date && filter?.date?.length) {
                    if (isToday(moment(filter.date[0])) && isToday(moment(filter.date[1]))) {
                        count--;
                    }
                }
            });
        }
        if (_eventFilter) {
            count += _eventFilter !== 'all' ? 1 : 0;
        } else {
            count += eventFilter !== 'all' ? 1 : 0;
        }

        return count;
    }

    function closeCFS() {
        setCfsError(false);
        setShowCFS(false);
        if (lastCFSEvent) {
            let element = document.querySelector('.collapsible.id-' + lastCFSEvent);
            if (element) {
                element.scrollIntoView({
                    behavior: 'smooth'
                })
            }
        }
    }

    function openCFS(cfsId: string, currentEventId: string) {
        if (!window.adobeIMS?.isSignedInUser()) {
            window.adobeid.redirect_uri = window.location.origin + `/products/${productId}/${eventId}?cfs=true`
            window.adobeIMS.signIn();
            return;
        }
        setCfsLoading(true);
        let pdfData: any = null;
        let isSkmsCfs = eventService.isSkmsCfs(currentEventId, productId);
        eventService.getCFS(cfsId, currentEventId, isSkmsCfs)
            .then((response: any) => response.data)
            .then((cfsObject: any) => {
                pdfData = atob(cfsObject.response.fileContent)

                window.PDFJS = PDFJS;
                 PDFJS.GlobalWorkerOptions.workerSrc = pdfjsWorker;
                var loadingTask = PDFJS.getDocument({ data: pdfData });
                loadingTask.promise.then(function (pdf: any) {
                    let canvasHolder: any = document.querySelector('.cfs-container'),
                        oldCanvas = document.querySelector('.cfs-container canvas');

                    while (oldCanvas) {
                        canvasHolder.removeChild(oldCanvas);
                        oldCanvas = document.querySelector('.cfs-container canvas');
                    }

                    let generatePDFPage = function (pageNumber: any, pdfObj: any) {
                        pdfObj.getPage(pageNumber).then(function (page: any) {
                            var scale = 1.5;
                            var viewport = page.getViewport({ scale: scale });
                            var canvas = document.createElement('canvas');

                            document.getElementById('the-canvas');
                            var context = canvas.getContext('2d');
                            canvas.height = viewport.height;
                            canvas.width = viewport.width;
                            canvas.classList.add('the-canvas');
                            canvasHolder.appendChild(canvas);

                            var renderContext = {
                                canvasContext: context,
                                viewport: viewport
                            };
                            var renderTask = page.render(renderContext);
                            renderTask.promise.then(function () {
                                if (pageNumber === 1) {
                                    window.scrollTo(0, 0);
                                    setShowCFS(true);
                                    setLastCFSEvent(eventId);
                                    setCfsLoading(false);
                                }
                                if (pageNumber < pdfObj.numPages) {
                                    generatePDFPage(++pageNumber, pdfObj)
                                }
                            });
                        });
                    }

                    generatePDFPage(1, pdf)

                }, function (reason: any) { });

            })
            .catch((error: any) => {
                console.error('Error in events PDF generation:', error);
                omega_capture(
                    `Error in events PDF generation: ${error.message || error.toString()}`,
                    "event",
                    "error"
                );
                if (pdfData) {
                    const byteString = pdfData;
                    const arrayBuffer = new ArrayBuffer(byteString.length);
                    const int8Array = new Uint8Array(arrayBuffer);
                    for (let i = 0; i < byteString.length; i++) {
                        int8Array[i] = byteString.charCodeAt(i);
                    }
                    const blob = new Blob([int8Array], { type: 'application/pdf' });
                    let _navigator: any = window.navigator
                    if (_navigator?.msSaveBlob) {
                        _navigator.msSaveBlob(blob, "cfs-" + eventId + ".pdf");
                    }
                } else {
                    setCfsError(true);
                    setShowCFS(true);
                }
                setCfsLoading(false);
                window.scrollTo(0, 0);
                setLastCFSEvent(eventId);
            });
    }


    function onFilterChange(_eventType?: any) {
       
        let filter = filterObj.getValue();
        
        filterObj = FilterStorage.init(cloudId);
        filterObj.setContext({
            type: 'product',
            cloud: cloudId
        });
        filterObj.setValue('products', productId);
        
        // Preserve eventIds filter if it exists
        if(filter?.eventIds && filter.eventIds.length) {
            filterObj.setValue('eventIds', filter.eventIds);
        }
        
        if(filter?.date && filter?.date?.length ){
             filterObj.setValue('date',[filter.date[0],filter.date[1]]);
             
             // When the date changes, we need to fetch all events for this date range for the dropdown
             const tempFilter = { ...filterObj.getValue() };
             if (tempFilter.eventIds) {
                 delete tempFilter.eventIds; // Remove event IDs filter to get all events
             }
             
             // Get all events for the date range
             const allIncidents = eventService.getIncidentsByDate(tempFilter || {}, 'all', 'all', statusFilter);
             setAllEvents(allIncidents);
        }

        const newFilter = filterObj.getValue();

        let incidents: any = eventService.getIncidentsByDate(newFilter || {}, 'all', 'all', statusFilter);
        setScheduledMaintenences(eventService.getScheduledMaintenance(newFilter || {}));
        setFilterChanged(incidents);
        setEvents(incidents);
        setFilterCount(getFilterCount(_eventType));
    }

    function onUpdateStatusFilter(status: any) {
        if (status.value === Status.Scheduled) {
            setEventFilter('all');
            setFilterCount(getFilterCount('all'));

        }
        OMEGA.init().updateAndTrack("event", [{
            ...eventDefaultValue,
            feature: cloudName + "-" + "product page" + " filters",
            attributes: {
                status: status.value
            },
            widget: {
                name: "Status_filter",
                type: "form"
            },
            search: {
                term: status.value
            }
        }]);
        setStatusFilter(status);

    }
    function updateStatusFilter(status: string) {
        setStatusFilter(STATUS_FILTER_VALUES.get(status));
        if (statusRef) {
            statusRef.setState({
                inputValue: "",
                menuIsOpen: false,
                value: STATUS_FILTER_VALUES.get(status)
            });
        }

        OMEGA.init().updateAndTrack("event", [{
            ...eventDefaultValue,
            attributes: {
                status: STATUS_FILTER_VALUES.get(status)
            },
            widget: {
                name: "Status filter",
                type: "form"
            },
            search: {
                term: STATUS_FILTER_VALUES.get(status)
            }
        }]);
    }
    function onUpdateEventFilter(eventType: any) {

        updateStatusFilter('all');
        setEventFilter(eventType);
        setFilterCount(getFilterCount(eventType));

        OMEGA.init().updateAndTrack("event", [{
            ...eventDefaultValue,
            feature: cloudName + "-" + "product page" + " filters",
            attributes: {
                event_Type: eventType
            },
            widget: {
                name: "event_type_filter",
                type: "panel"
            },
            search: {
                term: eventType
            }
        }]);

    }

    function showScheduledEvents() {
        return ((statusFilter && statusFilter.value === 'all') && (eventFilter === 'all' || eventFilter === 'maintenance')) || (statusFilter  && statusFilter.value === Status.Scheduled)
    }

    function isCurrentDaySection(dayEvent: any, index: number) {
        return dayEvent.formatedDate === locales.current || index === 0;
    }

    function getProductEventsSeparator() {
        return (
            <MyEventsToggle
                isOn={isSubscribedView || preferMyEvents}
                onChange={(enabled) => (enabled ? handleClickMyEvents() : handleClickAllProductEvents())}
                allLabel={locales.all}
                label={locales.my_events}
                infoText={locales.my_events_icon_info}
                tooltipId="product-my-events"
                tooltipExpanded={tooltipExpanded}
                onTooltipShow={() => setTooltipExpanded(true)}
                onTooltipHide={() => setTooltipExpanded(false)}
                switchId="my-product-events-tab"
                ariaControls="events-content"
                wrapperClassName="product-events-tabs"
                onShowingText={locales.showing_my_events}
                offShowingText={locales.showing_all_events}
            />
        );
    }

    function renderDaySectionHeader(dayEvent: any, index: number) {
        if (isCurrentDaySection(dayEvent, index)) {
            return getProductEventsSeparator();
        }
        return <h3>{dayEvent.formatedDate}</h3>;
    }

    function renderEventList() {
        HideFooter(false);

        filterObj = FilterStorage.init(cloudId);
        filterObj.setContext({
            type: 'product',
            cloud: cloudId
        });

        let filter = filterObj.getValue(), filterExists = false;
        if ((filter?.regions && filter?.regions?.length > 0) || (filter?.offerings && filter?.offerings?.length > 0) || eventFilter !== "all" || (statusFilter && statusFilter.value !== STATUS_FILTER_VALUES.get('all')?.value)) {
            filterExists = true;
        }

        const { dayEvents, scheduled } = getFilteredEventsForView();

        return (
            <div className="product-list-container">
                <div className="day-container-header">{getProductEventsSeparator()}</div>
                {
                    (statusFilter && statusFilter.value !== Status.Scheduled) ?
                        dayEvents.map((dayEvent: any, index: number) => {
                            return (
                                <div className="day-container" key={index}>
                                    <div className="day-container-header">
                                        <h3>{dayEvent.formatedDate}</h3>
                                    </div>
                                    <div className="day-container-content">
                                    {
                                        dayEvent.incidents.map((incident: any, hindex: number) => <EventTile openCFS={openCFS} event={incident} productId={productId} key={hindex} isHistory={true} isSubscribed={Subscribed(incident, subscriptions)} page="event" subscriptionLoading={loadingSubscription} error={subscriptionError} productName={productName} />)
                                    }
                                    {
                                        (!(dayEvent?.incidents?.length)) ? <span className="status-msg"><i className="event-icon available "></i>{filterExists || (isSubscribedView && events.some((day: any) => day.incidents?.length)) ? <i>{locales.no_event_found}</i> : <i>{locales.all_available}</i>}</span> : ''
                                    }
                                    </div>
                                </div>
                            )
                        }) : ''
                }
                {
                    (showScheduledEvents() && scheduled.length) ?
                        <div className="day-container scheduled-list" >
                            <div className="day-container-header"><h3>{locales.scheduled_history}</h3></div>
                            {
                                scheduled.map((maintenence: any, hindex: number) => <EventTile event={maintenence} productId={productId} key={hindex} isHistory={true} isSubscribed={Subscribed(maintenence,subscriptions)} page="event" subscriptionLoading={loadingSubscription} error={subscriptionError} productName={productName} />)
                            }
                        </div> : ''
                }
                {
                    (statusFilter && statusFilter.value === Status.Scheduled && !scheduled.length) ?
                        <div className="day-container scheduled-list" ><div className="day-container-header"><h3>{locales.scheduled_history}</h3></div><span className="status-msg"><i className="event-icon available "></i>{locales.no_cmr_found}</span></div> : ''
                }
            </div>
        );
    }

    function filterOfferingsForMyEvents(offeringList: any[]) {
        if (!isMyEventsViewActive()) {
            return offeringList;
        }
        const myOfferingIds = eventService.getMyOfferingIdsForProduct(productId, selfSubscriptions, entitlements, subscriptions);
        if (!myOfferingIds) {
            return offeringList;
        }
        return offeringList.map((offering: any) =>
            myOfferingIds.has(String(offering.id)) ? offering : {
                ...offering,
                events: undefined,
                incidents: [],
                formattedMaintenanceDate: undefined,
            }
        );
    }

    function filterHistoryOfferingsForMyEvents(historyData: any) {
        if (!isMyEventsViewActive()) {
            return historyData;
        }
        const filteredOfferings = filterOfferingsForMyEvents(historyData.productHistoryData || []);
        return {
            ...historyData,
            productHistoryData: filteredOfferings,
        };
    }

    function renderProductTable() {

        filterObj = FilterStorage.init(cloudId);
        filterObj.setContext({
            type: 'product',
            cloud: cloudId
        });

        let filter = filterObj.getValue(),
            date = moment().format('YYYY-MM-DD'),
            history: boolean = false;

        if (filter?.date && filter.date.length === 2) {
            history = isHistory([moment(filter?.date[0]), moment(filter?.date[1])]);
        } else {
            filterObj.setValue('date', [date, date])
        }

        let historyList: any = [], offeringData: any = [];


        if (history) {
            historyList = eventService.filterProductsByDate(serviceRegistry, filter || {}, productId, "offering", isMyEventsViewActive() ? eventService.getMyOfferingIdsForProduct(productId, selfSubscriptions, entitlements, subscriptions) : undefined);
            historyList = filterHistoryOfferingsForMyEvents(historyList);
        } else {
            // Narrows each offering's own counts down to incidents I'm actually subscribed to,
            // instead of just deciding whether to show the offering at all with its full count.
            const myEventsMatcher = isMyEventsViewActive() ? eventService.buildMyEventsMatcher(subscriptions, selfSubscriptions, entitlements) : null;
            offeringData = eventService.filteredOfferings(serviceRegistry, filter || {}, productId, undefined, myEventsMatcher);
        }
        return (
            <div>
            <div className="product-tab-content product-list-container comm-container">{renderCommunications(eventFilter, offeringData)}</div>
            <ProductTable
                eventFilter={eventFilter}
                filter={filterObj}
                productName={productName}
                onStatusFilter={onUpdateStatusFilter}
                onEventFilter={onUpdateEventFilter}
                onRedirect={setSelectedOfferings}
                currentTab={setCurrentTab}
                onSetCustomDate = {setCustomDate}
                isHistory={history}
                productList={history ? historyList : offeringData}
                page={"services"}
                showCanceledMaintenace={true}
                showMyEventsToggle={true}
                isMyEvents={isSubscribedView}
                preferMyEvents={preferMyEvents}
                onAllClick={handleClickAllProductEvents}
                onMyEventsClick={handleClickMyEvents}
                myEventsTooltipId="product-services-my-events"
                myEventsSwitchId="my-product-services-tab"
                myEventsWrapperClassName="product-events-tabs"
            />
            </div>
        );

    }

    function renderCommunications(_eventType?: any, productList?: any){
        if (_eventType === "announcement" || _eventType === "all"){
            return events.map((dayEvent: any, index: number) => {

                if (dayEvent.formatedDate == "Current"){
                    return dayEvent.incidents.map((incident: any, hindex: number) => {
                        if (isCommunication(incident.eventType) ){
                            return (
                                <div key={hindex}>
                                {
                                    <EventTile event={incident} key={index} isHistory={false} isSubscribed={Subscribed(incident,subscriptions)} subscriptionLoading={loadingSubscription}
                                    />
                                }
                                </div>
                            );
                        }
                    })

                }
            });
        }
    }

    function renderServices() {
        HideFooter(false);
        return (
            <div>
                {renderProductTable()}
            </div>
        );
    }

    function renderServiceFilter() {

        if (!loading && cloudId) {
          
            return (
               <Filter
                    product={productId}
                    type='product'
                    cloudName={cloudName}
                    defaultOffering={selectedOffering}
                    cloud={cloudId}
                    clearAll={clearAll}
                    onFilter={onFilterChange}
                    clearOffering={setSelectedOfferings}
                    updateDate={loadHistory}
                    customDate={customDate}
                    customRegions={customRegions}
                    customEventIds={customeventIds}
                    clearEventFilter={setEventFilter}
                    events={allEvents}
        
                />
            )
        } else {
            return (
                <>
                    <div className="fake-title">{locales.filter_by}</div>
                    <Spinner size="10" />
                </>
            );
        }

    }

    function displayEventFilter() {

        return (
            <div id="event-filter">
                <EventFilter active={eventFilter} onEventFilter={onUpdateEventFilter} />
            </div>
        );

    }

    function renderProductEventsContent() {
        if (isSubscribedView && !window.adobeIMS?.isSignedInUser()) {
            return (
                <div className="product-list-container">
                    <div className="day-container-header">
                        {getProductEventsSeparator()}
                    </div>
                    <EmptyMyEventsMessage
                        title={locales.my_events}
                        message={locales.my_events_anonymous_user_sign_in}
                        buttonText={locales.my_events_sign_in_button}
                        type={SubscriptionType.Offering}
                    />
                </div>
            );
        }
        if (isSubscribedView && window.adobeIMS?.isSignedInUser() && subscriptionError) {
            return (
                <div className="error-info">
                    <p>{parse(locales.api_error_overview)}</p>
                </div>
            );
        }
        return renderEventList();
    }

    function renderProductDetail() {
        return (
            currentTab === "events" ?
                <div id="events-content" role="tabpanel" aria-labelledby="events-tab">
                    <div className="col-md-3 offset-md-9 status-filter">
                        <label htmlFor="status-select">Status filter</label>
                        <Select
                            ref={(ref: ElementRef<any>) => {
                                if (ref) {
                                    statusRef = ref;
                                }
                            }}
                            inputId="status-select"
                            classNamePrefix="status-select"
                            isClearable={true}
                            defaultValue={STATUS_FILTER_VALUES.get('all')}
                            placeholder={locales.all_status}
                            options={Array.from(STATUS_FILTER_VALUES.values())}
                            aria-label="Filter by Status"
                            onChange={onUpdateStatusFilter}
                            noOptionsMessage={() => locales.search_no_results}
                            components={{
                                ClearIndicator: (props: any) => {
                                    const { components } = require('react-select');
                                    const Clear = components.ClearIndicator as React.ComponentType<any>;
                                    return (
                                        <Clear
                                            {...props}
                                            innerProps={{
                                                ...props.innerProps,
                                                "aria-hidden": false,
                                                role: "button",
                                                tabIndex: 0,
                                                "aria-label": "Clear all selected options",
                                                onKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => {
                                                    if (e.key === "Enter" || e.key === " ") {
                                                        e.preventDefault();
                                                        props.innerProps.onMouseDown?.(e as any);
                                                    }
                                                }
                                            }}
                                        />
                                    );
                                }
                            }}
                            styles={{
                                ...selectStyles,
                                noOptionsMessage: (provided: any) => ({
                                    ...provided,
                                    color: '#595959'
                                })
                            }}
                            onKeyDown={e => {
                                if ((e.key === 'Enter' || e.key === ' ') && statusRef && !statusRef.state.menuIsOpen) {
                                    e.preventDefault();
                                    statusRef.setState({ menuIsOpen: true });
                                }
                            }}
                        />
                    </div>
                    {loading || isWaitingForMyEventsData() ? <>{
                        HideFooter(true)
                    }<Spinner /></> : renderProductEventsContent()}
                </div>
                :
                <div id="services-content" role="tabpanel" aria-labelledby="services-tab">
                    {loading || isWaitingForMyEventsData() ? <>{
                        HideFooter(true)
                        }<Spinner /> </>: renderServices()}
                </div>
        );
    }

    function getOfferingNames(){
    var filter = filterObj.getValue();
    var offerings="";

    if(filter?.offerings && filter?.offerings?.length>0){
        filter.offerings.forEach((offering:any,index:number,offeringarr:any)=>{
            if(index === offeringarr.length - 1)
            offerings += serviceRegistry.getOfferingNameofOffer(offering);
            else
            offerings += serviceRegistry.getOfferingNameofOffer(offering) + ", ";
        })
    }
    return offerings;

    }

    return (
        <div className="event-wrapper product-page">
            <Banner isParentLoading={loading} id={productId} isProduct={true} productName={productName} allEvents={isMyEventsViewActive() ? getFilteredEventsForView().dayEvents : events} offerings={getOfferingNames()}/>

            <div className={`overlay ${(showCFS || cfsLoading) ? 'active' : ''}`}>
                {cfsLoading ? <Spinner /> : ''}
            </div>
            <div className={`cfs-container ${showCFS ? 'active' : ''}`}>
                <div className="close-cfs" onClick={closeCFS}>×</div>
                <div className={`cfs-error ${cfsError ? 'active' : ''}`} onClick={(e: any) => {
                    if (e.target?.classList?.contains('home-link')) {
                        histroyAPI.push('/');
                    }
                }}>
                    {parse(locales.cfs_error)}
                    <a href="#/" className="close-csf-error" onClick={closeCFS}>×</a>
                </div>
            </div>

            <div className="container">
                {
                    error ? <GenericError /> :
                        <>
                            <BreadCrumbs cloudName={cloudName} productName={productName} isLoading={loading} page={"product"} offerings={getOfferingNames()} productId={productId}  cloudId={cloudId}  clear={setClearAll} currentTab={setCurrentTab}/>
                            {
                                productName ? <h1 className="product-name title">{productName}</h1> : <MyLoader />
                            }
                            <ul className="tabs" role="tablist" aria-label="Product page navigation">
                                {isServices
                                    ? <li 
                                        id="services-tab"
                                        className={currentTab === "services" ? `active` : ""} 
                                        onClick={() => { setCurrentTab("services"); }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                setCurrentTab("services");
                                            }
                                        }}
                                        tabIndex={0}
                                        role="tab"
                                        aria-selected={currentTab === "services"}
                                        aria-controls="services-content"
                                        aria-label={`${locales.services_tab} tab, ${currentTab === "services" ? 'selected' : 'not selected'}`}
                                    >
                                        {locales.services_tab}
                                    </li>
                                    : ""
                                }
                                <li 
                                    id="all-events-tab"
                                    className={currentTab === "events" ? `active` : ""} 
                                    onClick={() => { setStatusFilter(STATUS_FILTER_VALUES.get('all'));setCurrentTab("events"); }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            setStatusFilter(STATUS_FILTER_VALUES.get('all'));
                                            setCurrentTab("events");
                                        }
                                    }}
                                    tabIndex={0}
                                    role="tab"
                                    aria-selected={currentTab === "events"}
                                    aria-controls="events-content"
                                    aria-label={`${locales.events_tab} tab, ${currentTab === "events" ? 'selected' : 'not selected'}. These events are filtered based on users entitlements and preferences`}
                                >
                                    {locales.events_tab}
                                </li>
                            </ul>
                            <div id="filter-button">
                                <button className="btn" onClick={() => { setFilterClicked(!filterClicked); toggle_visibility("side-panel", "event-filter") }}>
                                    <i className={filterClicked || filterCount ? "event-icon filter active" : "event-icon filter"}></i> {filterCount ? <span>({filterCount})</span> : ''}
                                </button>
                            </div>
                            <div className="row">
                                <div className="col-md-3 side-panel">
                                    <div id="side-panel">
                                        <div className="mobile-eventfilter">{displayEventFilter()}</div>
                                        <hr className="mobile-divider" />
                                        {renderServiceFilter()}
                                    </div>
                                </div>
                                <div className="col-md-9 event-container">
                                    <div className="desktop-eventfilter">{displayEventFilter()}</div>
                                    {renderProductDetail()}
                                </div>
                            </div>
                        </>
                }

            </div>
        </div>
    )
}
